import { MemberInterface } from "@swivl-mono/types";
import { Button, ButtonColor, ButtonSize, ButtonVariant } from "@swivl-mono/ui";
import { FC } from "react";
import { TiDelete } from "react-icons/ti";

import { getAgentName } from "./MembersList.Helpers";

interface Props {
  value: MemberInterface;
  onDelete: (memberId: number) => void;
}

export const MembersListItem: FC<Props> = ({ value, onDelete }) => {
  return (
    <div className="group flex min-h-fit w-[300px] rounded-[5px] border border-grey-300 bg-grey-50 px-3 py-2.5">
      <span className="flex-1">{getAgentName(value)}</span>
      <div className="opacity-0 transition-opacity duration-200 group-hover:opacity-100">
        <Button onClick={() => onDelete(value.id)} size={ButtonSize.SMALL} color={ButtonColor.WHITE} variant={ButtonVariant.ICON}>
          <TiDelete size="24px" color="rgba(255, 75, 52, 1)" />
        </Button>
      </div>
    </div>
  );
};
